module.exports = __webpack_public_path__ + "img/pcBanner17.8114ea1c.png";